import React from 'react';

import AboutHotel from '../../containers/AboutHotel';
import ExtraItems from '../../containers/ExtraItemsContainer';
import Facts from '../../containers/Facts';
import Paper from '../Paper';
import PaperSeparator from '../Paper/PaperSeparator';
import EmptyAboutHotel from './EmptyAboutHotel';
import styles from './hotelInfo.module.css';
import ReviewBlock from '../ReviewBlock';

const padding = 20;

interface HotelInfoPropsType {
  isLastReview: boolean;
  hasRating: boolean;
  hasFacts: boolean;
  hasExtraItems: boolean;
  hasAboutHotel: boolean;
  isHotelOnly: boolean;
  isExpertReviewExists: boolean;
}
/**
 * DISCLAIMER
 *
 * Придумано слишком много вариаций размещения информации,
 * из-за этого неизвестно как себя поведет система при пересечении всех возможных состояний.
 * Тут покрыта хотя бы известная часть.
 */
const HotelInfo = ({
  hasRating,
  isLastReview,
  hasFacts,
  hasExtraItems,
  hasAboutHotel,
  isHotelOnly,
  isExpertReviewExists,
}: HotelInfoPropsType) => {
  const hasSomething = hasFacts || hasRating || isLastReview;

  if (!hasExtraItems && !hasSomething && !hasAboutHotel) {
    return <EmptyAboutHotel />;
  }

  if (hasExtraItems && !hasSomething && hasAboutHotel) {
    return (
      <Paper padding={padding}>
        <div className={styles.container}>
          <div className={styles.singleContainerColumn}>
            <ExtraItems />
          </div>
          <span
            className={styles.verticalSeparator}
            style={{ padding: -padding }}
          />
          <div className={styles.singleContainerColumn}>
            <AboutHotel />
          </div>
        </div>
      </Paper>
    );
  }

  return (
    <div className={styles.container}>
      {(hasFacts || hasExtraItems) && (
        <div className={styles.leftColumn}>
          {isExpertReviewExists && <ReviewBlock />}
          <Paper padding={padding}>
            {hasFacts && <Facts isMobile={false} />}
            {!isHotelOnly && hasExtraItems && (
              <>
                {hasFacts && <PaperSeparator margin={padding} />}
                <ExtraItems />
              </>
            )}
          </Paper>
        </div>
      )}
      <div className={styles.rightColumn}>
        {hasSomething || hasAboutHotel ? (
          <>
            <Paper className={styles.paperWithMargin} padding={padding}>
              <AboutHotel />
            </Paper>
          </>
        ) : (
          <EmptyAboutHotel />
        )}
      </div>
    </div>
  );
};

export default HotelInfo;
